export const auditText = (value, fallback = '-') => {
  if (value === undefined || value === null) return fallback;

  if (typeof value === 'string') {
    const normalized = value.trim();
    return normalized || fallback;
  }

  if (['number', 'boolean', 'bigint'].includes(typeof value)) {
    return String(value);
  }

  return fallback;
};

export const getAuditChangeReason = (event) => {
  const changedData = event?.changed_data;

  if (!changedData || typeof changedData !== 'object' || Array.isArray(changedData)) {
    return '';
  }

  return auditText(changedData.change_reason, '');
};

export const getTaxAuditAction = (record) => {
  const recordedAction = auditText(record?.audit_action, '');
  if (recordedAction) return recordedAction;

  return String(record?.['deleted?'] ?? '').trim().toLowerCase() === 'yes'
    ? 'Deleted'
    : 'Recorded change';
};

export const formatAppliedTaxes = (appliedTaxes) => {
  if (!Array.isArray(appliedTaxes)) return '-';

  const labels = appliedTaxes
    .map((tax) => {
      if (tax && typeof tax === 'object' && !Array.isArray(tax)) {
        return auditText(tax.value ?? tax.label ?? tax.tax_name, '');
      }
      return auditText(tax, '');
    })
    .filter(Boolean);

  return labels.length > 0 ? labels.join(', ') : '-';
};
